import React from "react";
export const Eye = ({width="20px",height="20px"}) => (
  <svg fill="#000" width={width} height={height} viewBox="0 0 512 512">
    <path d="M256,421C147.78,421,49.91,358.72.58,258.51a5.7,5.7,0,0,1,0-5C49.91,153.28,147.78,91,256,91s206.09,62.26,255.42,162.47a5.7,5.7,0,0,1,0,5C462.09,358.72,364.22,421,256,421ZM12,256c47.78,94.82,141,153.6,244,153.6S452.17,350.82,500,256c-47.78-94.82-141-153.6-244-153.6S59.83,161.18,12,256Z" />
    <path d="M256,352.71A96.71,96.71,0,1,1,352.71,256,96.82,96.82,0,0,1,256,352.71Zm0-182A85.33,85.33,0,1,0,341.33,256,85.43,85.43,0,0,0,256,170.67Z" />
  </svg>
);
export const Eyeselect = ({width="20px"}) => (
  <svg fill="#000" width={width} x="0px" y="0px" viewBox="0 0 512 512">
    <g>
      <path
        d="M71.3,341c-1.4,0-2.8-0.5-3.8-1.5C39.7,314.2,17,284,0.5,250.3c-0.8-1.6-0.8-3.4,0-5
                C49.9,145.1,147.7,82.8,256,82.8c19.3,0,38.5,2,57.4,6c3.1,0.7,5.1,3.7,4.4,6.8s-3.7,5.1-6.8,4.4c-18.1-3.8-36.5-5.8-55-5.8
                C153,94.2,59.8,153,12,247.8c15.8,31.4,37.2,59.6,63.1,83.3c2.3,2.1,2.5,5.7,0.4,8C74.4,340.3,72.8,341,71.3,341L71.3,341z"
      />
      <path
        d="M256,412.8c-40.9,0.1-81.3-8.9-118.4-26.4c-2.8-1.3-4.1-4.7-2.7-7.6c1.3-2.8,4.7-4.1,7.6-2.7l0,0
                c35.5,16.7,74.3,25.3,113.5,25.3c103,0,196.2-58.8,244-153.6c-24.7-48.9-62-89.1-108-116.4c-2.7-1.6-3.6-5.1-2-7.8
                c1.6-2.7,5.1-3.6,7.8-2c48.8,28.9,88.1,71.6,113.7,123.7c0.8,1.6,0.8,3.4,0,5C462,350.5,364.2,412.8,256,412.8z"
      />
      <path
        d="M256,344.5c-21.1,0.1-41.7-6.8-58.4-19.7c-2.6-1.8-3.3-5.3-1.5-7.9c1.8-2.6,5.3-3.3,7.9-1.5
                c0.2,0.1,0.4,0.3,0.5,0.4c14.8,11.3,32.9,17.4,51.5,17.3c47.1-0.1,85.3-38.2,85.3-85.3c0.1-18.6-6-36.7-17.3-51.5
                c-2.1-2.4-1.8-6,0.5-8c2.4-2.1,6-1.8,8,0.5c0.2,0.2,0.3,0.4,0.4,0.5c12.9,16.7,19.8,37.3,19.7,58.4
                C352.6,301.2,309.3,344.4,256,344.5z"
      />
      <path
        d="M165.2,247.1h-0.4c-3.1-0.2-5.5-2.9-5.3-6.1c3.4-48.1,41.7-86.3,89.7-89.7c3.1-0.2,5.9,2.2,6.1,5.3
                c0.2,3.1-2.2,5.9-5.3,6.1c-42.4,3-76.1,36.7-79.1,79.1C170.6,244.8,168.2,247.1,165.2,247.1z"
      />
      <path
        d="M23.6,497.8c-3.1,0-5.7-2.6-5.7-5.7c0-1.5,0.6-2.9,1.7-4L492.2,15.5c2.4-2,6-1.6,8,0.9c1.7,2.1,1.7,5.1,0,7.1
                L27.7,496.1C26.6,497.2,25.2,497.8,23.6,497.8z"
      />
    </g>
  </svg>
);

export const Dropdown = () => (
  <svg
    fill="#000"
    x="0px"
    y="0px"
    width="10px"
    height="10px"
    viewBox="0 0 10 10"
  >
    <g>
      <path d="M0,2.5h10l-5,5L0,2.5z" />
    </g>
  </svg>
);

export const Notification = () => (
  <svg
    fill="#fff"
    x="0px"
    y="0px"
    width="20px"
    height="20px"
    viewBox="0 0 16 19"
  >
    <path d="M8,19c1.1,0,2-0.9,2-1.9H6C6,18.1,6.9,19,8,19z M14,13.2V8.3c0-3-1.6-5.5-4.5-6.2V1.5C9.5,0.7,8.8,0,8,0S6.5,0.7,6.5,1.5 v0.7C3.6,2.8,2,5.3,2,8.3v4.9l-2,1.9v1h16v-1L14,13.2z" />
  </svg>
);

export const getIcons = (el) => {
  switch (el.toLowerCase()) {
    case "dashboard":
      return (
        <svg
          fill="#fff"
          x="0px"
          y="0px"
          width="18px"
          height="18px"
          viewBox="0 0 18 18"
        >
          <path d="M0,10h8V0H0V10z M0,18h8v-6H0V18z M10,18h8V8h-8V18z M10,0v6h8V0H10z" />
        </svg>
      );
    case "master":
      return (
        <svg
          fill="#fff"
          x="0px"
          y="0px"
          width="19px"
          height="15px"
          viewBox="0 0 19 15"
        >
          <path
            d="M0,3.8h3.5V0H0V3.8z M5.2,15h3.5v-3.8H5.2V15z M0,15h3.5v-3.8H0V15z M0,9.4h3.5V5.6H0V9.4z M5.2,9.4h3.5V5.6H5.2V9.4z
                M10.4,0v3.8h3.5V0H10.4z M5.2,3.8h3.5V0H5.2V3.8z M10.4,9.4h3.5V5.6h-3.5V9.4z M10.4,15h3.5v-3.8h-3.5V15z M15.5,0v3.8H19V0H15.5z
                M15.5,9.4H19V5.6h-3.5V9.4z M15.5,15H19v-3.8h-3.5V15z"
          />
        </svg>
      );
    case "transactions":
      return (
        <svg
          fill="#fff"
          x="0px"
          y="0px"
          width="18px"
          height="21px"
          viewBox="0 0 18 21"
        >
          <g>
            <path
              d="M2.2,3.3v4.4c0,0.4,0.2,0.8,0.4,1c0.3,0.2,0.6,0.2,0.9,0c0.3-0.2,0.4-0.6,0.4-1V5.5h12.3c0.3,0,0.6-0.2,0.8-0.6
                    c0.2-0.3,0.2-0.8,0-1.1c-0.2-0.3-0.4-0.6-0.8-0.6L2.2,3.3z"
            />
            <path
              d="M14.5,0c-0.2,0-0.5,0.1-0.6,0.3c-0.2,0.2-0.3,0.5-0.3,0.8c0,0.3,0.1,0.6,0.3,0.8l2.6,3.3v0c0.2,0.2,0.4,0.3,0.6,0.3
                    c0.2,0,0.5-0.1,0.6-0.3C17.9,5,18,4.7,18,4.4c0-0.3-0.1-0.6-0.3-0.8l-2.6-3.3l0,0C14.9,0.1,14.7,0,14.5,0L14.5,0z"
            />
            <path
              d="M17.1,3.3c-0.2,0-0.4,0.1-0.6,0.3l-2.6,3.3v0c-0.2,0.2-0.3,0.5-0.3,0.8c0,0.3,0.1,0.6,0.3,0.8c0.2,0.2,0.4,0.3,0.6,0.3
                    c0.2,0,0.5-0.1,0.6-0.3l2.6-3.3l0,0C17.9,5,18,4.7,18,4.4c0-0.3-0.1-0.6-0.3-0.8C17.5,3.4,17.3,3.3,17.1,3.3L17.1,3.3z"
            />
            <path
              d="M14.9,12.2c-0.2,0-0.5,0.1-0.6,0.3c-0.2,0.2-0.3,0.5-0.3,0.8v2.2H1.8c-0.3,0-0.6,0.2-0.8,0.6c-0.2,0.3-0.2,0.8,0,1.1
                    c0.2,0.3,0.4,0.6,0.8,0.6h14.1v-4.4h0c0-0.3-0.1-0.6-0.3-0.8C15.4,12.3,15.2,12.2,14.9,12.2L14.9,12.2z"
            />
            <path
              d="M0.8,15.5c-0.2,0-0.4,0.2-0.6,0.4C0.1,16.1,0,16.3,0,16.6c0,0.3,0.1,0.5,0.3,0.7l2.6,3.3C3.1,21,3.5,21.1,3.8,21
                    c0.3-0.1,0.5-0.4,0.6-0.8c0.1-0.4,0-0.8-0.2-1.1l-2.6-3.3C1.3,15.6,1.1,15.4,0.8,15.5L0.8,15.5z"
            />
            <path
              d="M3.5,12.2c-0.2,0-0.4,0.1-0.6,0.3l-2.6,3.3C0.1,16,0,16.3,0,16.6c0,0.3,0.1,0.6,0.3,0.8c0.2,0.2,0.4,0.3,0.6,0.3
                    c0.2,0,0.5-0.1,0.6-0.3l2.6-3.3c0.2-0.2,0.3-0.5,0.3-0.8c0-0.3-0.1-0.6-0.3-0.8C4,12.3,3.8,12.2,3.5,12.2L3.5,12.2z"
            />
          </g>
        </svg>
      );
    case "reports":
      return (
        <svg
          fill="#fff"
          x="0px"
          y="0px"
          width="17px"
          height="17px"
          viewBox="0 0 17 17"
        >
          <g>
            <g>
              <path
                d="M11.3,0H1.9C0.9,0,0,0.9,0,1.9l0,13.2c0,1,0.8,1.9,1.9,1.9h13.2c1,0,1.9-0.9,1.9-1.9V5.7L11.3,0z M4.7,13.2
                            c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9C5.7,12.8,5.2,13.2,4.7,13.2z M4.7,9.4C4.2,9.4,3.8,9,3.8,8.5
                            s0.4-0.9,0.9-0.9S5.7,8,5.7,8.5S5.2,9.4,4.7,9.4z M4.7,5.7c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9
                            S5.2,5.7,4.7,5.7z M10.4,6.6V1.4l5.2,5.2H10.4z"
              />
            </g>
          </g>
        </svg>
      );
    case "config":
      return (
        <svg
          fill="#fff"
          x="0px"
          y="0px"
          width="19px"
          height="19px"
          viewBox="0 0 19 19"
        >
          <path
            d="M18.8,15.5l-7.8-7.9c0.8-2,0.3-4.3-1.3-6C7.9-0.1,5.3-0.4,3.2,0.5l3.7,3.7L4.3,6.9L0.6,3.1c-1,2.1-0.6,4.7,1.1,6.4
                    c1.6,1.6,4,2.1,6,1.3l7.8,7.9c0.3,0.3,0.9,0.3,1.2,0l2-2C19.1,16.4,19.1,15.8,18.8,15.5z"
          />
        </svg>
      );
    case "admin":
      return (
        <svg
          fill="#fff"
          x="0px"
          y="0px"
          width="16px"
          height="16px"
          viewBox="0 0 16 16"
        >
          <path d="M8,8c2.2,0,4-1.8,4-4s-1.8-4-4-4S4,1.8,4,4S5.8,8,8,8z M8,10c-2.7,0-8,1.3-8,4v2h16v-2C16,11.3,10.7,10,8,10z" />
        </svg>
      );
    default:
      return null;
  }
};

export const Setting = () => (
  <svg
    fill="#fff"
    x="0px"
    y="0px"
    width="20px"
    height="20px"
    viewBox="0 0 18 18"
  >
    <path
      d="M15.9,9.9c0-0.3,0.1-0.6,0.1-0.9c0-0.3,0-0.6-0.1-0.9l2-1.5c0.2-0.1,0.2-0.4,0.1-0.6L16.1,3c-0.1-0.2-0.4-0.3-0.6-0.2
        l-2.3,0.9c-0.5-0.4-1-0.7-1.6-0.9l-0.3-2.4c0-0.2-0.2-0.4-0.5-0.4H7.1C6.9,0,6.7,0.2,6.7,0.4L6.3,2.8C5.8,3,5.3,3.3,4.8,3.6L2.5,2.7
        C2.3,2.7,2,2.7,1.9,3L0.1,6.1C0,6.3,0,6.5,0.2,6.6l2,1.5c0,0.3-0.1,0.6-0.1,0.9s0,0.6,0.1,0.9l-2,1.5c-0.2,0.1-0.2,0.4-0.1,0.6
        L1.9,15c0.1,0.2,0.4,0.3,0.6,0.2l2.3-0.9c0.5,0.4,1,0.7,1.6,0.9l0.3,2.4c0,0.2,0.2,0.4,0.5,0.4h3.7c0.2,0,0.4-0.2,0.5-0.4l0.3-2.4
        c0.6-0.2,1.1-0.5,1.6-0.9l2.3,0.9c0.2,0.1,0.5,0,0.6-0.2l1.9-3.1c0.1-0.2,0.1-0.4-0.1-0.6L15.9,9.9z M9,12.4c-1.9,0-3.5-1.5-3.5-3.4
        S7.1,5.6,9,5.6s3.5,1.5,3.5,3.4S10.9,12.4,9,12.4z"
    />
  </svg>
);

export const Account = () => (
  <svg
    fill="#fff"
    x="0px"
    y="0px"
    width="20px"
    height="20px"
    viewBox="0 0 19 19"
  >
    <path
      d="M9.5,0C4.3,0,0,4.3,0,9.5S4.3,19,9.5,19S19,14.7,19,9.5S14.7,0,9.5,0z M9.5,2.8c1.6,0,2.9,1.3,2.9,2.8s-1.3,2.9-2.9,2.9
        S6.7,7.3,6.7,5.7S7.9,2.8,9.5,2.8z M9.5,16.3c-2.4,0-4.5-1.2-5.7-3.1c0-1.9,3.8-2.9,5.7-2.9c1.9,0,5.7,1,5.7,2.9
        C14,15.1,11.9,16.3,9.5,16.3z"
    />
  </svg>
);

export const Filter = () => (
  <svg
    fill="#777"
    x="0px"
    y="0px"
    width="16px"
    height="11px"
    viewBox="0 0 16 11"
  >
    <path d="M6.2,11h3.6V9.2H6.2V11z M0,0v1.8h16V0H0z M2.7,6.4h10.7V4.6H2.7V6.4z" />
  </svg>
);

export const Sort = () => (
  <svg
    fill="#777"
    x="0px"
    y="0px"
    width="16.5px"
    height="11.5px"
    viewBox="0 0 16.5 11.5"
  >
    <g>
      <rect y="4.3" width="10" height="1.7" />
      <rect y="8.6" width="5" height="1.7" />
      <rect width="15" height="1.7" />
      <polygon points="14.6,8.8 14.6,3.5 13.4,3.5 13.4,8.8 11.5,8.8 14,11.5 16.5,8.8 	" />
    </g>
  </svg>
);

export const CancelIcon = ({fillColor="#0086FF",style}) => (
  <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
    <path
      d="M10.3202 12.1483L9.0835 10.9058L7.84683 12.1483L7.02433 11.32L8.261 10.0833L7.02433 8.84663L7.84683 8.02413L9.0835 9.26079L10.3202 8.02413L11.1485 8.84663L9.906 10.0833L11.1485 11.32L10.3202 12.1483ZM6.16683 0.166626H1.50016C0.852663 0.166626 0.333496 0.685793 0.333496 1.33329V10.6666C0.333496 11.3141 0.852663 11.8333 1.50016 11.8333H6.056C5.74683 11.3025 5.5835 10.6958 5.5835 10.0833C5.5835 8.15246 7.15266 6.58329 9.0835 6.58329C9.28183 6.58329 9.47433 6.60079 9.66683 6.62996V3.66663L6.16683 0.166626ZM5.5835 4.24996V1.04163L8.79183 4.24996H5.5835Z"
      fill={fillColor}
    />
  </svg>
)